export default "__VITE_ASSET__DXPpqqu1__"